// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3Z-cV","row":"styles_row__11tkA"};